module.exports = __webpack_public_path__ + "static/media/cat-lady4W.c39c1481.png";